<template>
	<div class="i-surveys-form-input">
		<form-item v-bind="$attrs">
			<!-- 总分显示 -->
			<div class="input_control" v-if="showSum">
				<van-field
					:value="sumValue"
					placeholder="总分"
					:rules="rules"
					:name="`${itemKey}_sum`"
					readonly
				>
					<template #left-icon>总分</template>
					<template
						#right-icon
						v-if="options[0] && options[0].suffixName"
						>{{ options[0].suffixName }}</template
					>
				</van-field>
			</div>
			<template v-if="!showSum && !showAverage">
				<div
					class="input_control"
					v-for="(val, idx) in options"
					:key="`input_${itemKey}_${idx}`"
				>
					<van-field
						:value="singleValue"
						placeholder="自动计算值"
						:rules="rules"
						:name="itemKey"
						readonly
					>
						<template #left-icon v-if="val.name">{{
							val.name
						}}</template>
						<template #right-icon v-if="val.suffixName">{{
							val.suffixName
						}}</template>
					</van-field>
				</div>
			</template>
		</form-item>
	</div>
</template>

<script>
import FormItem from "./form-item.vue";

export default {
	components: { FormItem },
	props: {
		value: {
			type: [String, Number],
			default: "",
		},
		placeholder: {
			type: String,
			default: "",
		},
		options: {
			type: Array,
			default: () => [],
		},
		rules: {
			type: Array,
			default: () => [],
		},
		itemKey: {
			type: String,
			default: "",
		},
		needCount: {
			type: [Boolean, Number],
			default: 0,
		},
	},
	data: () => ({
		separator: "@%_@%",
	}),
	computed: {
		// 判断是否显示总分和平均分
		hasBothValues() {
			return (
				typeof this.value === "string" && this.value.includes("@%_@%")
			);
		},
		showSum() {
			return this.hasBothValues;
		},
		showAverage() {
			return this.hasBothValues;
		},
		// 获取总分值
		sumValue() {
			if (this.hasBothValues) {
				const [sum] = this.value.split("@%_@%");
				return sum;
			}
			return "";
		},
		// 获取平均值
		averageValue() {
			if (this.hasBothValues) {
				const [, average] = this.value.split("@%_@%");
				return average;
			}
			return "";
		},
		// 单一值（兼容旧版本）
		singleValue() {
			if (this.hasBothValues) {
				return "";
			}
			return this.value;
		},
		isDisabled() {
			return this.$route.query.formType === "preview";
		},
	},
	methods: {
		inputVal(val, valIndex) {
			if (this.isDisabled) return;
			const newVal = JSON.parse(JSON.stringify(this.getModelValue));
			newVal[valIndex] = val.trim();
			this.$emit("input", newVal.join(this.separator));
		},
		validatorCount() {
			console.log("value", this.value);
			let counts = this.value.split("@%_@%");
			return (
				counts.reduce((acc, currentValue) => {
					let number = Number(currentValue);
					return acc + (isNaN(number) ? 0 : number);
				}, 0) == 100
			);
		},
	},
	mounted() {
		console.log("11111111", this.options);
	},
};
</script>

<style scoped>
.input_control {
	margin-bottom: 8px;
}

.input_control:last-child {
	margin-bottom: 0;
}
</style>
